import {COLORS} from '@/utils/constants';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many people does your business currently employ?
 * 
 * == baseline
 * jobs_t0_men_t0_number
 * jobs_t0_women_t0_number
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: How many people does your business employ?
 * 
 * == final
 * jobs_t1_men_t1_number
 * jobs_t1_women_t1_number
 * 
 * @param props 
 * @returns 
 */
export const percentageOfFemaleEmployeesBeforeAndAfterChartCalculation = (props: any) => {
    const sum = (submissions: any, key: string) => 
        submissions.reduce((acc: number, submission: any) => acc + submission[key] || 0, 0);
     
    return {
        chart: {
            type: 'column',
        },
        title: {
            text: 'KPI: Percentage of female employees before and after',
            align: 'left',
        },
        tooltip: {
            formatter: function (){
                let value = this.series.name + '<br />';
                value += `<b>${this.point.y?.toFixed(2)} (${this.point.percentage?.toFixed(1)}%)</b>`;

                return value;
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        xAxis: {
            categories: ['Before', 'After'],
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
        series: [
            {
                name: 'Women',
                type: 'column',
                color: COLORS.e4ImpactOrange,
                data: [
                    sum(props.baselineSubmissions, 'jobs_t0_women_t0_number'),
                    sum(props.finalSubmissions, 'jobs_t1_women_t1_number'),
                ],
            },
            {
                name: 'Man',
                type: 'column',
                color: COLORS.e4ImpactBlue,
                data: [
                    sum(props.baselineSubmissions, 'jobs_t0_men_t0_number'),
                    sum(props.finalSubmissions, 'jobs_t1_men_t1_number')
                ],
            },
        ],
    } as Highcharts.Options;
}